"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Keyboard_1 = require("../../../_Core/Keyboard");
var Spinner_1 = require("../../../Animations/Spinner");
var SearchableNestedDropdown_context_1 = require("../SearchableNestedDropdown.context");
var Dropdown_styles_1 = require("./Dropdown.styles");
var RowItem_1 = require("./RowItem");
exports.default = React.forwardRef(function (_, ref) {
    var _a = React.useContext(SearchableNestedDropdown_context_1.SndContext), Parent = _a.Parent, Value = _a.Value, Items = _a.Items, SelectFolder = _a.SelectFolder, IsLoading = _a.IsLoading, SelectItem = _a.SelectItem, SelectHeaderControl = _a.SelectHeaderControl, HelpMessage = _a.HelpMessage, LabelledBy = _a.LabelledBy;
    var orderedListRef = React.createRef();
    React.useEffect(function () {
        if (document.activeElement.nodeName !== "INPUT" && !IsLoading && Items && Items.length > 0) {
            orderedListRef.current.firstChild.focus();
        }
    }, [Items, orderedListRef]);
    React.useImperativeHandle(ref, function () { return ({
        selectItemInDropdown: function () {
            if (orderedListRef.current && orderedListRef.current.firstChild) {
                orderedListRef.current.firstChild.focus();
            }
        },
    }); });
    var FireSelectionEvent = function (item) {
        if (item.IsFolder) {
            SelectFolder(item);
        }
        else {
            SelectItem(item, { Item: item, Parent: Parent });
        }
    };
    var BuildRow = function (item) {
        var isSelected = (Value && item.Id === Value.Id);
        var handleKeyDown = function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (Keyboard_1.IsUpArrow(e) && !document.activeElement.previousSibling) {
                SelectHeaderControl();
            }
            else if (Keyboard_1.IsUpArrow(e) && document.activeElement.previousSibling) {
                document.activeElement.previousSibling.focus();
            }
            else if (Keyboard_1.IsDownArrow(e) && document.activeElement.nextSibling) {
                document.activeElement.nextSibling.focus();
            }
            else if (Keyboard_1.IsRightArrow(e) && item.IsFolder) {
                FireSelectionEvent(item);
            }
            else if (Keyboard_1.IsEnter(e)) {
                FireSelectionEvent(item);
            }
            else if (Keyboard_1.IsHome(e)) {
                orderedListRef.current.firstChild.focus();
            }
            else if (Keyboard_1.IsEnd(e)) {
                orderedListRef.current.lastChild.focus();
            }
        };
        return (React.createElement(Dropdown_styles_1.ListItem, { onKeyDown: handleKeyDown, key: item.Id, tabIndex: -1 },
            React.createElement(RowItem_1.default, { IsSelected: isSelected, Item: item, OnItemClick: FireSelectionEvent })));
    };
    return (React.createElement(Dropdown_styles_1.ListWrapper, null, IsLoading ?
        React.createElement(Dropdown_styles_1.CenteredWrapper, null,
            React.createElement(Spinner_1.Spinner, null))
        :
            Items && Items.length ?
                React.createElement(Dropdown_styles_1.ListItems, { "aria-labelledby": LabelledBy, ref: orderedListRef }, Items.map(function (item) { return React.createElement(BuildRow, __assign({ key: item.Id }, item)); }))
                :
                    React.createElement(Dropdown_styles_1.CenteredWrapper, null,
                        React.createElement(Dropdown_styles_1.MessageText, null, HelpMessage))));
});
